/* oxlint-disable no-inner-declarations */
import { ok } from '@oazapfts/runtime';
import * as rq from '@tanstack/react-query';

import { tasksV1CardsCleanUpDoneUpdate } from '../fetch-client';
import { ListTasks } from '../queries/list-tasks';
import { useFetchOpts } from '../use-fetch-opts';

export namespace ArchiveTasks {
  export type Input = void;
  export type Output = void;

  export function useMutation() {
    const getOpts = useFetchOpts();
    const queryClient = rq.useQueryClient();
    const [listTasksFilters] = ListTasks.useGetFiltersFromQueryParams();

    return rq.useMutation<Output, unknown, Input>({
      async mutationFn() {
        const opts = await getOpts();
        await ok(tasksV1CardsCleanUpDoneUpdate({}, opts));
        return;
      },
      async onSuccess() {
        await Promise.all([
          queryClient.invalidateQueries({
            queryKey: ListTasks.key({ filters: listTasksFilters }),
          }),
          queryClient.invalidateQueries({
            queryKey: ['project-management'],
          }),
        ]);
      },
    });
  }
}
